module.exports = __webpack_public_path__ + "static/media/orange_covid_pin.676accf3.png";